import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { UserButton } from '@clerk/clerk-react';
import { LayoutGrid, Plus, ClipboardList } from 'lucide-react';

function NavItem({ to, label, icon: Icon, end }: { to: string; label: string; icon: typeof LayoutGrid; end?: boolean }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-bold transition-all whitespace-nowrap ${
          isActive
            ? 'bg-accent-100 dark:bg-accent-500/10 text-accent-600 dark:text-accent-500'
            : 'text-text-secondary hover:bg-border/40 hover:text-text-primary'
        }`
      }
    >
      <Icon size={15} />
      {label}
    </NavLink>
  );
}

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-transparent">
      <header className="sticky top-0 z-10 border-b border-border bg-surface/80 backdrop-blur-xl px-4 py-3 flex items-center justify-between gap-3">
        {/* Logo */}
        <div className="flex items-center gap-2.5 shrink-0">
          <img src="/logo_miyo.webp" alt="Bitmiyo" className="w-10 h-10 object-contain shrink-0" />
          <span className="font-black text-lg text-text-primary hidden sm:inline tracking-tight" style={{ fontFamily: 'var(--font-heading)' }}>
            Bitmiyo Sınıf
          </span>
        </div>

        {/* Nav */}
        <nav className="flex items-center gap-1 overflow-x-auto no-scrollbar min-w-0">
          <NavItem to="/panel" end label="Panelim" icon={LayoutGrid} />
          <NavItem to="/sinif/yeni" label="Yeni Sınıf" icon={Plus} />
          <NavItem to="/panel" label="Görev Yönetimi" icon={ClipboardList} />
        </nav>

        <div className="shrink-0">
          <UserButton />
        </div>
      </header>

      <main>{children}</main>
    </div>
  );
}
